import React, { useEffect, useState } from "react";
import "./style.scss";
import { TourProvider } from "@reactour/tour";
import GuidelinesList from "../../components/Guidelines/GuidelinesList";

const HomePage = () => {
  const steps = [
    {
      selector: ".first-step",
      content: "Please select the client",
    },
    {
      selector: ".second-step",
      content: "Select Marketplace",
    },
    {
      selector: ".third-step",
      content: "Select Category",
    },
    {
      selector: ".forth-step",
      content: "Select Sub-Category",
    },
    {
      selector: ".fifth-step",
      content: "Angle Set List",
    },
  ];
  return (
    <div className="home_page_main_wrapper">
      {/* <TourProvider
        steps={steps}
        scrollSmooth
        styles={{
          badge: (base) => ({ ...base, background: "#3b60e4" }),
          dot: (base, { current }) => ({
            ...base,
            background: current ? "#3b60e4" : "#ccc",
          }),
          popover: (base) => ({
            ...base,
            background: "#dedede",
            borderRadius: 10,
          }),
        }}
        disableInteraction={(clickProps) => clickProps.currentStep < 2}
        onClickHighlighted={(event, clickProps) => {
          if (clickProps.currentStep < 2) {
            event.preventDefault();
            clickProps.setCurrentStep(
              Math.min(clickProps.currentStep + 1, clickProps.steps.length - 1)
            );
          }
        }}
        onClickClose={({ setIsOpen, meta, setSteps, setMeta }) => {
          if (meta && meta === "tour-2") {
            setMeta("tour-1");
            setSteps(steps);
          } else {
            setIsOpen(false);
          }
        }}
        onClickMask={({ setIsOpen, meta, setSteps, setMeta }) => {
          if (meta && meta === "tour-2") {
            setMeta("tour-1");
            setSteps(steps);
          } else {
            setIsOpen(false);
          }
        }}
      > */}
      <GuidelinesList />
      {/* </TourProvider> */}
    </div>
  );
};
export default HomePage;
